import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1307Model } from './kymw1307.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1307GetSummaryTableModel } from './vo/kymw1307-get-summary-table.model';
import { GetSummaryTableService } from './api-services/get-summary-table.service';

/**
 * 予算・計画・実績表画面を管理するクラス
 *
 * @export KYMW1307Component
 * @class KYMW1307Component
 */
@Component({
  selector: 'app-kymw1307',
  templateUrl: 'kymw1307.component.html',
  styleUrls: ['kymw1307.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1307Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw1307Model: KYMW1307Model = new KYMW1307Model();

  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;

  /**
   * Creates an instance of KYMW1307Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1307Component
   */
  constructor(
    // 項番2473 START 連合会問合せNo.45対応
    // private dialogService: PlessDialogService,
    private dialogService: PlessDialogServiceSub,
    // 項番2473 END 連合会問合せNo.45対応
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getSummaryTableService: GetSummaryTableService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1307Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1307';

    document.getElementById('btn_Close').focus();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1307Component
   */
  public setInterfaceParam(param: any): void {

    const getSummaryTableVO: KYMW1307GetSummaryTableModel = new KYMW1307GetSummaryTableModel();
    getSummaryTableVO.displayMode = param.displayMode;
    getSummaryTableVO.orderCode = param.orderCode;
    getSummaryTableVO.mediumType = param.mediumType;

    getSummaryTableVO.sellAreaCode = param.sellAreaCode;
    getSummaryTableVO.orderNumQuotaCode = param.orderNumQuotaCode;
    getSummaryTableVO.coopCode = param.coopCode;
    getSummaryTableVO.classCode = param.classCode;
    getSummaryTableVO.middleClassCode = param.middleClassCode;
    getSummaryTableVO.smallClassCode = param.smallClassCode;
    getSummaryTableVO.pageNum = param.pageNum;
    getSummaryTableVO.buyerCode = param.buyerCode;
    getSummaryTableVO.nonCarryFlag = param.nonCarryFlag;
    getSummaryTableVO.orderClientCode = param.orderClientCode;                  // 発注先コード
    getSummaryTableVO.orderClientKanji = param.orderClientKanji;                // 発注先名称
    getSummaryTableVO.payeeClientCode = param.payeeClientCode;                  // 支払先コード
    getSummaryTableVO.payeeClientKanji = param.payeeClientKanji;                // 支払先名称

    // 予算・計画・実績表取得API呼び出し
    this.getSummaryTableService.execute(this.kymw1307Model, getSummaryTableVO,
      (data: any) => this.checkPCodeServiceSuccessFunc(data));
  }

  /**
   * 予算・計画・実績表取得API成功処理
   *
   * @param data APIレスポンス
   */
  public checkPCodeServiceSuccessFunc(data: any): void {
    // サーバ取得データ反映
    this.kymw1307Model.updateKYMW1307(data);
  }

}
